import { AccountExternalPagesVisibility, ClientAccount } from '@lune-climate/lune'
import { IconButton, Tooltip } from '@lune-fe/lune-ui-lib'
import WebAssetOffOutlinedIcon from '@mui/icons-material/WebAssetOffOutlined'
import WebAssetOutlinedIcon from '@mui/icons-material/WebAssetOutlined'
import { FC, useState } from 'react'

import { PublicPagesModal } from 'views/Settings/ClientAccounts'

const PublicPagesButtonAndModal: FC<{
    account: ClientAccount
}> = ({ account }) => {
    const [openModal, setOpenModal] = useState<boolean>(false)
    const disabled =
        !account.handle || account.externalPagesVisibility !== AccountExternalPagesVisibility.PUBLIC

    return (
        <>
            <Tooltip
                title={
                    disabled
                        ? 'Unavailable — Customer pages are hidden or not configured'
                        : 'Customer pages'
                }
            >
                <IconButton
                    leadingIcon={disabled ? <WebAssetOffOutlinedIcon /> : <WebAssetOutlinedIcon />}
                    disabled={disabled}
                    size={'sm'}
                    style={'floating'}
                    onClick={() => setOpenModal(true)}
                />
            </Tooltip>
            <PublicPagesModal
                account={account}
                open={openModal}
                onModalClose={() => setOpenModal(false)}
            />
        </>
    )
}

export default PublicPagesButtonAndModal
